var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKlmAllInclusive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 21.75H13.5V15.15L22.5 4.50002H10.8L7.875 0.150024L6 1.35002L8.1 4.50002H2.25L11.25 15.15V21.75H9C7.725 21.75 6.75 22.725 6.75 24H18C18 22.725 17.025 21.75 15.75 21.75ZM13.125 8.17502C14.175 8.17502 15.075 9.07502 15.075 10.125C15.075 11.175 14.175 12.075 13.125 12.075C12.075 12.075 11.175 11.175 11.175 10.125C11.175 9.07502 12.075 8.17502 13.125 8.17502Z",
    fill: "#00A1DE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlmAllInclusive);
export default __webpack_public_path__ + "static/media/klm-allInclusive.3d379219cc0065b278f3ce26a2b341b5.svg";
export { ForwardRef as ReactComponent };